import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";

// #215 (E2) / Multi-Seed: Seed-Quelle (im Image gebackene brain-packages/* + optionale
// Kunden-Quellen) als neues Gitea-Template-Repo seeden — manuell vom Admin ausgelöst.
// Idempotent (existiert → created:false).
export interface SeedResult {
  created: boolean;
  overwritten?: boolean;
  fileCount: number;
  fullName: string;
  source?: string;
}

export interface SeedSource {
  name: string;
}

// Verfügbare Seed-Quellen (GET /gitea/seeds).
export function useGiteaSeeds(enabled = true): UseQueryResult<SeedSource[], Error> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: ["gitea", "seeds"],
    enabled: enabled && !!session,
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<SeedSource[]>("/gitea/seeds");
    },
  });
}

export function useSeedRepo(): UseMutationResult<SeedResult, Error, { source: string; repoName: string; overwrite?: boolean }> {
  const { session, logout } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ source, repoName, overwrite }) => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.post<SeedResult>("/gitea/seed", { source, repoName, overwrite });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ["gitea", "repos"] }),
  });
}
